<template>
  <EditDialog
    :visible="visible"
    :title="$t('organization_structure.edit_tags_group')"
    @close="$emit('close')"
  >
    <template v-slot:content>
      <v-form
        v-if="form.tagsGroup._id"
        v-model="form.valid"
        ref="edit_tagsGroup_form"
      >
        <v-text-field
          required
          outlined
          dense
          data-private
          autofocus
          v-model="form.tagsGroup.name"
          :disabled="loading"
          :hideDetails="Boolean(form.tagsGroup.name)"
          :class="Boolean(form.tagsGroup.name) ? 'mb-4' : ''"
          :rules="[
            name => !!name || $t('validation.form.this_field_is_required'),
          ]"
          :label="`${$t('groups.group_name')}*`"
        />
        <MultipleSelect
          hideDetails
          class="mb-4"
          itemValue="id"
          :showSelectAll="!tagsOptions.length > 100"
          :label="$t('common.tag_other')"
          :value="form.tagsGroup.tags"
          :options="tagsOptions"
          :loading="fetching"
          :disabled="loading"
          @search="getTags"
          @change="form.tagsGroup.tags = $event"
        />
        <div class="d-flex">
          <p class="blue-grey--text text--darken-3 ma-0 pa-0 me-2">
            {{ $t('common.enabled') }}
          </p>
          <v-switch
            class="mt-0 pt-0"
            hide-details
            v-model="form.tagsGroup.isEnabled"
            :ripple="false"
            :disabled="loading"
          />
        </div>
      </v-form>
    </template>
    <template v-slot:footer>
      <div>
        <v-btn
          text
          rounded
          color="blue-grey"
          :disabled="loading"
          @click="$emit('close')"
          >{{ $t('common.button.cancel') }}</v-btn
        >
        <v-btn
          rounded
          color="blue"
          elevation="0"
          class="white--text"
          :loading="loading"
          :disabled="loading"
          @click="handleSave"
          >{{ $t('common.button.save') }}</v-btn
        >
      </div>
    </template>
  </EditDialog>
</template>

<script>
import MultipleSelect from '@/components/Core/MultipleSelect.vue'
import EditDialog from '@/containers/OrganizationStructureView/Shared/EditDialog.vue'

import api from '@/api'
import mixin from '@/mixins/mixin.vue'

const SORT_BY_SCORE = '_score'

export default {
  name: 'EditTagsGroupDialog',

  mixins: [mixin],

  components: {
    MultipleSelect,
    EditDialog,
  },

  props: {
    organizationId: String,
    loading: Boolean,
    visible: Boolean,
    tagsGroup: {
      type: Object,
      required: false,
      default: () => {
        return { name: '', tags: [], id: '' }
      },
    },
  },

  data() {
    return {
      fetching: false,
      tags: [],
      form: {
        valid: true,
        tagsGroup: {
          name: '',
          tags: [],
          id: '',
        },
      },
    }
  },

  watch: {
    visible(visible) {
      if (!visible) this.resetForm()
    },

    tagsGroup(newVal) {
      this.form.tagsGroup = {
        ...newVal,
        tags: newVal?.tags?.map?.(tag => tag?.id ?? tag),
      }
    },
  },

  mounted() {
    this.getTags()
  },

  computed: {
    tagsOptions() {
      return this.tags?.filter?.(tag => tag.isEnabled) ?? []
    },
  },

  methods: {
    async getTags(terms) {
      this.fetching = true
      const payload = {
        limit: 100,
        sort: {
          by: terms ? SORT_BY_SCORE : 'updatedAt',
          order: 'desc',
        },
        from: 0,
      }
      if (terms) payload.terms = terms

      try {
        const response = await api.tag.getStreamTags(
          this.organizationId,
          payload
        )

        this.tags = response?.data?.results?.map(item => item?.tag) ?? []
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.fetching = false
      }
    },

    handleSave() {
      this.$refs.edit_tagsGroup_form.validate()
      if (!this.form.valid) return
      this.$emit('save', this.form.tagsGroup)
    },

    resetForm() {
      this.form.tagsGroup = {
        name: '',
        tags: [],
        id: '',
      }
      this.$refs?.edit_tagsGroup_form?.reset?.()
    },
  },
}
</script>
